
<img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/>

<ion-content>

  <ion-menu-toggle class="SCWEB-menu-icon">
    <ion-button color="white">
      <img src="assets/img/shortcut-icon.png" class="SCWEB-menu-img" />
    </ion-button>
  </ion-menu-toggle>

  <div class="SCWEB-address-container" (click)="openSccToThisPage()">
    <p>Active concierge list</p>
    <ion-icon name="arrow-redo-circle-outline"></ion-icon>
  </div>

  <div class="page-wrapper">

    <div class="name-img-wrapper">
      <img src="assets/img/shortcut-icon.png" class="img" />
      <div class="name">Create a Concierge account</div>
    </div>

    <div class="middle-info">

      <div class="section-header">Personal information</div>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="concierge.fullName" name="fullName" type="text" #email="ngModel" required
          placeholder="Full name">
        </ion-input>
      </ion-item>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="concierge.email" name="email" type="email" #email="ngModel" required
          placeholder="Email">
        </ion-input>
      </ion-item>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="concierge.phone" name="phone" type="text" #email="ngModel" required
          placeholder="Phone">
        </ion-input>
      </ion-item>

      <!-- <ion-item class="input-item" lines="none">
        <ion-select [(ngModel)]="concierge.businessLocationID" value="" placeholder="Choose a location" [interfaceOptions]="interfaceOptions('Location', 'Add new locations in Business settings.')">
          <ion-select-option *ngFor="let l of businessLocations" value="{{l.id}}">{{l.name}}, {{l.address.city}}, {{l.address.state}}</ion-select-option>
        </ion-select>
      </ion-item> -->

      <p class="disclaimer">Concierge accounts get full booking privileges for your Pros' scheduled time, and can manage active chats between Pros and Clients. They will receive an email with unique login information to the <a href="https://app.getshortcut.co">Shortcut Web Booking platform</a>. You may deactivate their Concierge account at any time.</p>

      <ion-button class="SC-long-button submit-button" color="marine" (click)="submit()" type="submit" block>
        Submit
      </ion-button>

      <p class="submit-status" *ngIf="submitStatus">{{submitStatus}}</p>
      <p class="error-status" *ngIf="errorStatus">{{errorStatus}}</p>

    </div>
  </div>

</ion-content>

<ion-footer slot="fixed" class="SC-support-footer">
  <span class="support-button" (click)="openPage('https://getshortcut.co/faq')">FAQ</span>
  <span class="support-button" (click)="adminChat()">Live chat</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/privacy')">Privacy policy</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/terms')">Terms of service</span>
</ion-footer>